import React, { useState } from "react";
import "./DatasheetModal.css";

function DatasheetModal({ sensor, onClose }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    contact: ""
  });

  const [readyToDownload, setReadyToDownload] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // You can send details to backend here
    setReadyToDownload(true);

    // Trigger file download automatically
    setTimeout(() => {
      const link = document.createElement("a");
      link.href = sensor.pdf;
      link.download = sensor.name + "-datasheet.pdf";
      link.click();
      onClose(); // close modal after download
    }, 800);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content small-popup">
        <button className="close-btn" onClick={onClose}>✖</button>

        {!readyToDownload ? (
          <>
            <h5 className="modal-title text-dark text-center mb-3">
              Enter Your Details
            </h5>
            <form onSubmit={handleSubmit}>
              <div className="mb-2">
                <label className="form-label fw-bold">Name</label>
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-2">
                <label className="form-label fw-bold">Email</label>
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>

              <div className="mb-2">
                <label className="form-label fw-bold">Contact Number</label>
                <input
                  type="tel"
                  name="contact"
                  className="form-control"
                  value={formData.contact}
                  onChange={handleChange}
                  required
                />
              </div>

              <button type="submit" className="btn btn-primary w-100 mt-2">
                Submit & Download
              </button>
            </form>
          </>
        ) : (
          <div className="text-center">
            <p>Preparing your download...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default DatasheetModal;
